"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _definitionhelpers = require("../../../utils/definitionhelpers");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- SWITCH : DEFINITION --------------- ++++++++++ */


var _default2 = {
  name: 'Switch',
  group: _definitionhelpers.groupNames.switches,
  props: {
    variant: {
      type: 'string',
      default: 'secondary',
      options: ['primary', 'secondary']
    },
    handleClick: {
      type: 'function',
      default: function _default() {
        return console.log('Clicked');
      },
      disabled: true,
      help: _definitionhelpers.helpMessages.functions
    },
    on: {
      type: 'boolean',
      options: [true, false],
      default: false
    },
    isStatic: {
      // Used to determine if Switch should update after every click
      //   or only when props.on changes.
      type: 'boolean',
      options: [true, false],
      default: false
    }
  }
};
exports.default = _default2;